import * as React from 'react';

import { NotFound as NotFoundComponent } from '@/components/Elements/NotFound';

export const NotFound = () => {
  return <NotFoundComponent />;
};
